import { render, staticRenderFns } from "./struggling-panel-card.vue?vue&type=template&id=62ec0218&scoped=true"
import script from "./struggling-panel-card.ts?vue&type=script&lang=ts&external"
export * from "./struggling-panel-card.ts?vue&type=script&lang=ts&external"
import style0 from "./struggling-panel-card.scss?vue&type=style&index=0&id=62ec0218&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec0218",
  null
  
)

export default component.exports